
require("./../../node_modules/@module-federation/nextjs-mf/src/include-defaults.js");
// features
import Watchlist from 'features/watchlist';
// hooks
import useProtectedRoute from 'hooks/useProtectedRoute';
// layouts
import MainLayout from 'global/MainLayout';
import SEO from 'global/SEO';
import { useSelector } from 'react-redux';
import { selectors } from 'global/MainLayout/slice';

function WatchlistPage() {
  useProtectedRoute();

  const { isSideWidgetOpen } = useSelector(selectors);

  return (
    <>
      <SEO title="Stockbit Watchlist" />
      <MainLayout isFlexibleWidth maxWidth={isSideWidgetOpen ? 980 : 1280}>
        <Watchlist />
      </MainLayout>
    </>
  );
}

export default WatchlistPage;
